export default "__VITE_ASSET__Deglzkri__"